export enum STORE_VARIABLE {
  SITE_NAME = 'siteName',
  SITE_ID = 'siteId'
}
